import React from 'react';
import { trackError } from '@/lib/monitoring/track-error';

export class DatadogErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    trackError(error, {
      component: errorInfo.componentStack || 'Unknown',
      action: 'react-error-boundary',
      metadata: { errorInfo },
    });
  }

  render() {
    if (this.state.hasError) {
      return React.createElement(
        'div',
        { className: 'error-boundary-fallback' },
        React.createElement('h2', null, 'Something went wrong.'),
        React.createElement(
          'button',
          { type: 'button', onClick: () => this.setState({ hasError: false }) },
          'Try again'
        )
      );
    }

    return this.props.children;
  }
}
